<div class="no-data">
  <p>No data available</p>
</div>
